<template>
    <div class="customer_details">
        <div class="content-header padl0">
            <div class="content-header-left">
                <div class="client_title">
                    <p> {{checkProperty(tenantDetails ,"name" )}}</p>
                    <span v-if="checkProperty(tenantDetails ,'typeDetails' ,'name')"><img
                            src="@/assets/images/icons/tick.svg" />{{checkProperty(tenantDetails ,'typeDetails'
                        ,'name')}}</span>
                </div>
            </div>
            <div class="content-header-right">
                <div class="client_actions">
                    <p>
                        <span class="statusspan "
                            :class="{'status_pending':checkProperty(tenantDetails ,'statusId')==1,'status_active':checkProperty(tenantDetails ,'statusId')==2,'status_rejected':checkProperty(tenantDetails ,'statusId')==3,'status_deleted':checkProperty(tenantDetails ,'statusId')==4}">
                            {{checkProperty(tenantDetails ,"statusDetails" ,'name')}}

                        </span>
                    </p>
                    <template v-if="checkProperty(tenantDetails ,'statusId')<=1">
                        <vs-dropdown class="msg_dropdown_icon" :vs-trigger-click="true">
                            <vs-button>
                                <template v-if="checkProperty(tenantDetails ,'statusId')<=1">
                                    Actions
                                </template>
                            </vs-button>
                            <vs-dropdown-menu class="loginx msg_dropdown actions_list">

                                <!-- <vs-dropdown-item>
                        <a  href.prevent  style="cursor:pionter;padding:3px 10px"   @click="goToDetails(tenantDetails._id)"><span>Details</span></a>
                    </vs-dropdown-item> -->
                                <vs-dropdown-item>
                                    <a href.prevent style="cursor:pionter;padding:3px 10px"
                                        @click="openApprovepopup(tenantDetails ,2,'Approve')"><span>Approve </span></a>
                                </vs-dropdown-item>
                                <vs-dropdown-item>
                                    <a href.prevent style="cursor:pionter;padding:3px 10px"
                                        @click="openApprovepopup(tenantDetails ,3,'Reject')"><span>Reject</span></a>
                                </vs-dropdown-item>
                                <!-- <vs-dropdown-item v-if="tr.statusId >=2">  
                        <a href.prevent style="cursor:pionter;padding:3px 10px"   @click="openApprovepopup(tr ,4 ,'Delete')"><span>Delete</span></a>
                    </vs-dropdown-item> -->
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </template>
                </div>

            </div>

        </div>





        <div class="main-tabs-content tabs_mob">
            <div class="tabs-content detail_page_sec customer_details">
                <vs-row vs-w="12" class="bg_white">
                    <vs-col vs-type="flex" class="mob-left">
                        <VuePerfectScrollbar class="scroll-area">
                            <div class="petitionTabs">
                                <vs-tabs>
                                    <vs-tab class="petition_tabs petition_details_tab">
                                        <vs-tabs position="left" color="danger" v-model="active_tab">
                                            <vs-tab label="Basic Info">
                                                <div class="tab-inner-content">
                                                    <div class="tabs-content-panel tab-pad-wrap">
                                                        <div class="main-list-wrap">
                                                            <div class="vx-row m-0 main-list-panel">

                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            First Name

                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"adminFirstName")?checkProperty(tenantDetails
                                                                                ,"adminFirstName"):'--'
                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Last Name
                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"adminLastName")?checkProperty(tenantDetails
                                                                                ,"adminLastName"):'--'
                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Name
                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"name")?checkProperty(tenantDetails
                                                                                ,"name"):'--'

                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Admin Email
                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"adminEmail")?checkProperty(tenantDetails
                                                                                ,"adminEmail"):'--'

                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Phone Number
                                                                            <span>
                                                                                <template
                                                                                    v-if="checkProperty(tenantDetails ,'phone')">
                                                                                    <template
                                                                                        v-if="checkProperty(tenantDetails ,'phoneCountryCode' ,'countryCallingCode')">{{checkProperty(tenantDetails
                                                                                        ,"phoneCountryCode"
                                                                                        ,'countryCallingCode')+"&nbsp;"}}
                                                                                    </template>{{checkProperty(tenantDetails
                                                                                    ,"phone") | formatPhone}}
                                                                                </template>
                                                                                <template v-else>--</template>
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Cust ID
                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"customId")?checkProperty(tenantDetails
                                                                                ,"customId"):'--'
                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Contact Email
                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"contactEmail")?checkProperty(tenantDetails
                                                                                ,"contactEmail"):'--'
                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            From Email
                                                                            <span>{{
                                                                                checkProperty(tenantDetails
                                                                                ,"fromEmail")?checkProperty(tenantDetails
                                                                                ,"fromEmail"):'--'

                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="vx-col md:w-1/2 w-full p-0" v-if="checkProperty(tenantDetails,'feiNumber')" >
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Federal Employer Identification Number
                                                                            
                                                                            <span>{{checkProperty(tenantDetails,'feiNumber')}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                               <div class="vx-col md:w-/1 w-full p-0">
                                                                <div class="lca_header_list" v-if="checkProperty(tenantDetails, 'feinDocs','length')>0">
                                                                    <div class="list__cnt">
                                                                      <!-- <div class="lca_doc_sec">
                                                                        <label v-if="checkProperty(tenantDetails ,'feinDocs')">FEIN Document or Latest Tax Return Document</label>
                                                                      </div> -->
                                                                      <div class="list-elements">
                                                                        <h4 v-if="checkProperty(tenantDetails ,'feinDocs')">FEIN Document or Latest Tax Return Document</h4>
                                                                        <ul>
                                                                            <template v-if="checkProperty(tenantDetails,'feinDocs','length')>0">
                                                                                <template v-for="(feinDoc ,index) in tenantDetails['feinDocs']">                       
                                                                                   <li :key="index" v-if="checkProperty(feinDoc,'status')" :title="checkProperty(feinDoc,'name')" @click="downloads3file(feinDoc)">        
                                                                                       
                                                                                        <figure >               
                                                                                            <img v-if="checkFileFormat(feinDoc['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                                                            <img v-else-if="checkFileFormat(feinDoc['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                                                            <img v-else-if="checkFileFormat(feinDoc['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                                                            <img v-else-if="checkFileFormat(feinDoc['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                                                            <img v-else-if="checkFileFormat(feinDoc['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                                                            <img v-else-if="checkFileFormat(feinDoc['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                                                            <img v-else-if="checkFileFormat(feinDoc['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                                                            <img v-else src="@/assets/images/main/icon-img.svg" /> 
                                                                                            <span class="download_icon"></span>
                                                                                        </figure> 
                                                                                        <!-- <a class="certified-name" :title="checkProperty(feinDoc,'name')">{{feinDoc.name}}</a> -->
                                                                                                 
                                                                                  </li>
                                                                                  
                                                                                </template>  
                                                                            </template>
                                                                          </ul>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                               </div>

                                                            </div>

                                                            <div class="vx-row m-0 main-list-panel">

                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>

                                                                            Street Address

                                                                            <span>
                                                                                {{
                                                                                checkProperty(tenantDetails ,"address"
                                                                                ,"line1")?checkProperty(tenantDetails
                                                                                ,"address" ,"line1"):'--'
                                                                                }}

                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Apt, Suite
                                                                            <span>{{
                                                                                checkProperty(tenantDetails ,"address"
                                                                                ,'line2')?checkProperty(tenantDetails
                                                                                ,"address" ,'line2'):'--'

                                                                                }}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0"
                                                                    v-if=" checkProperty(tenantDetails ,'address')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Location
                                                                            <span>
                                                                                <template v-if="
                                                                                 checkProperty(tenantDetails.address ,'locationDetails' ,'name')
                                                                                 || checkProperty(tenantDetails.address ,'stateDetails' ,'name')
                                                                                 || checkProperty(tenantDetails.address ,'countryDetails' ,'name')
                                                                               
        
                                                                                ">
                                                                                    {{checkProperty(tenantDetails.address
                                                                                    ,"locationDetails" ,'name')}}

                                                                                    {{checkProperty(tenantDetails.address
                                                                                    ,"stateDetails" ,'name')?',':''}}
                                                                                    {{checkProperty(tenantDetails.address
                                                                                    ,"stateDetails" ,'name')}}

                                                                                    {{checkProperty(tenantDetails.address
                                                                                    ,"countryDetails" ,'name')?',':''}}
                                                                                    {{checkProperty(tenantDetails.address
                                                                                    ,"countryDetails" ,'name')}}

                                                                                    {{checkProperty(tenantDetails
                                                                                    ,"address" ,'zipcode')?'-':''}}
                                                                                    {{checkProperty(tenantDetails
                                                                                    ,"address" ,'zipcode')}}
                                                                                </template>
                                                                                <template v-else>--</template>

                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="vx-row m-0 main-list-panel">

                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>

                                                                            Profile Status

                                                                            <span>{{checkProperty(tenantDetails
                                                                                ,'profCompleted')=="Yes"?'Completed':'Pending'}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>


                                                                <div class="vx-col md:w-1/3 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'slug')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Account Domain
                                                                            <span>  <a href="javascript:;" @click="getAccountDomain">https://{{checkProperty(tenantDetails
                                                                                ,'slug')}}.immibox.com</a></span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="vx-col md:w-1/3 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'idPrefix')">
                                                                    <div class="main-list">
                                                                        <p>

                                                                            Company Short Code
                                                                            <span>{{checkProperty(tenantDetails
                                                                                ,'idPrefix')}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>

                                                                            Configuration Status

                                                                            <span>{{checkProperty(tenantDetails
                                                                                ,'petConfigCompleted')?'Completed':'Pending'}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="vx-row m-0 main-list-panel">

                                                                <div class="vx-col md:w-1/3 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'logo')">
                                                                    <div class="main-list">
                                                                        <p>

                                                                            Logo

                                                                            <img class="file-icon upload-logo"
                                                                                :src="checkProperty(tenantDetails ,'logo')" />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/3 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'favicon')">
                                                                    <div class="main-list">
                                                                        <p>

                                                                            Favorite Icon

                                                                            <img class="file-icon upload-logo"
                                                                                :src="checkProperty(tenantDetails ,'favicon')" />
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>

                                            </vs-tab>
                                            <vs-tab label="Petitioner Details"
                                                v-if="checkProperty( tenantDetails ,'petitionerInfo')">
                                                
                                                <div class="tab-inner-content">
                                                    <div class="tabs-content-panel tab-pad-wrap">

                                                        <div class="main-list-wrap">
                                                            <div class="vx-row m-0 main-list-panel">
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'petitionerInfo' ,'name')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Full legal name of your company
                                                                            <span>{{checkProperty(tenantDetails
                                                                                ,'petitionerInfo' ,'name')}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory,'firstName')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            First Name
                                                                            <span>{{
                                                                                checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory,
                                                                                'firstName')
                                                                                ?
                                                                                checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory,'firstName'):'--'}}</span>

                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory,'lastName')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Last Name
                                                                            <span>{{
                                                                                checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory,
                                                                                'lastName') ?
                                                                                checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory,'lastName'):'--'}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails ,'petitionerInfo' ,'naicsCode') ||  checkProperty(tenantDetails ,'petitionerInfo' ,'phone')">
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'petitionerInfo' ,'naicsCode')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            NAICS Code (as per Tax Return)
                                                                            <span>{{tenantDetails['petitionerInfo'].naicsCode}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0" v-if="checkProperty(tenantDetails['petitionerInfo'],'feiNumber')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Federal Employer Identification Number
                                                                            <span>{{checkProperty(tenantDetails['petitionerInfo'], 'feiNumber')}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                               <div class="vx-col md:w-/1 w-full p-0">
                                                                <div class="lca_header_list" v-if="checkProperty(tenantDetails['petitionerInfo'],'feinDocs','length')>0">
                                                                    <div class="list__cnt">
                                                                      <div class="lca_doc_sec">
                                                                        <label v-if="checkProperty(tenantDetails['petitionerInfo'] ,'feinDocs')">FEIN Document or Latest Tax Return Document</label>
                                                                      </div>
                                                                      <div class="lca_doclist">
                                                                        <ul>
                                                                            <template v-if="checkProperty(tenantDetails['petitionerInfo'],'feinDocs','length')>0">
                                                                                <template v-for="(item ,index) in tenantDetails['petitionerInfo']['feinDocs']">                       
                                                                                   <li :key="index" v-if="checkProperty(feinDoc,'status')">        
                                                                                     <div class="file__name" @click="downloads3file(item)">   
                                                                                        <figure>               
                                                                                            <img v-if="checkFileFormat(item['mimetype']) =='pdf'" src="@/assets/images/main/pdf.svg" /> 
                                                                                            <img v-else-if="checkFileFormat(item['mimetype']) =='video_mime_types'" src="@/assets/images/main/film.png" />
                                                                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msDoc'" src="@/assets/images/main/doc.svg" />
                                                                                            <img v-else-if="checkFileFormat(item['mimetype']) =='zip'" src="@/assets/images/main/zip-file-format.png" />
                                                                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msPpt'" src="@/assets/images/main/ppt.svg" />
                                                                                            <img v-else-if="checkFileFormat(item['mimetype']) =='msXl'" src="@/assets/images/main/xls.svg" />
                                                                                            <img v-else-if="checkFileFormat(item['mimetype']) =='image'" src="@/assets/images/main/image.svg" />
                                                                                            <img v-else src="@/assets/images/main/icon-img.svg" /> 
                                                                                        </figure> 
                                                                                        <a class="certified-name" :title="checkProperty(feinDoc,'name')">{{feinDoc.name}}</a>
                                                                                     </div>
                                                                                                    
                                                                                  </li>
                                                                                </template>  
                                                                            </template>
                                                                          </ul>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                               </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails ,'petitionerInfo' ,'phone')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Phone Number
                                                                            <span>

                                                                                <template
                                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'] ,'phone')">
                                                                                    {{checkProperty(tenantDetails['petitionerInfo']
                                                                                    ,"phoneCountryCode"
                                                                                    ,'countryCallingCode')?checkProperty(tenantDetails['petitionerInfo']
                                                                                    ,"phoneCountryCode"
                                                                                    ,'countryCallingCode')+('&nbsp;'):''}}{{checkProperty(tenantDetails['petitionerInfo']
                                                                                    ,"phone")}}
                                                                                </template>
                                                                                <template v-else>--</template>

                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails,'petitionerInfo', 'address') || checkProperty(tenantDetails, 'petitionerInfo','feiNumber')">
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails, 'petitionerInfo','feiNumber')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Fax Number
                                                                            <span>
                                                                                <template
                                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'feiNumber')">
                                                                                    {{checkProperty(tenantDetails['petitionerInfo']
                                                                                    ,"feiNumber") |
                                                                                    formatPhone}}
                                                                                    {{checkProperty(tenantDetails['petitionerInfo']
                                                                                    ,'address')}}
                                                                                </template>
                                                                                <template v-else>--</template>


                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'] ,'address')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Address
                                                                            <span
                                                                                v-html="$options.filters.addressformat(tenantDetails['petitionerInfo'].address)"></span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="[50].indexOf(getUserRoleId)>-1 && checkProperty(tenantDetails['petitionerInfo'] ,'config' ,'commuEmails') && checkProperty(tenantDetails['petitionerInfo'] ,'config' ,'ptnrBriefDays')">
                                                                <div class="vx-col md:w-1/2 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Briefing Days
                                                                            <span>{{tenantDetails['petitionerInfo']['config']['ptnrBriefDays']}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            List of additional contacts to be notified
                                                                            <span>


                                                                                {{checkProperty(tenantDetails['petitionerInfo']
                                                                                ,"config" ,'commuEmails')}}



                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <template
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'] ,'authorizedSignatory')">
                                                                <h3 class="small-header mt-8">
                                                                    Representative/Authorized Signatory</h3>
                                                                <div class="vx-row m-0 main-list-panel">
                                                                    <div class="vx-col w-full p-0">
                                                                        <div class="main-list">
                                                                            <p>
                                                                                Name

                                                                                <span>
                                                                                    <span
                                                                                        v-if="checkProperty(tenantDetails['petitionerInfo'] ,'authorizedSignatory','name')">
                                                                                        {{
                                                                                        checkProperty(tenantDetails['petitionerInfo']
                                                                                        ,'authorizedSignatory','name')
                                                                                        }}
                                                                                    </span>
                                                                                    <span v-else>
                                                                                        {{checkProperty(tenantDetails['petitionerInfo'],'authorizedSignatory','firstName')}}
                                                                                        {{checkProperty(tenantDetails['petitionerInfo'],'authorizedSignatory','lastName')}}
                                                                                    </span>
                                                                                </span>
                                                                           
                                                                                <span>
                                                                                    {{checkProperty(tenantDetails['petitionerInfo'],'authorizedSignatory','title')}}
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                <div class="vx-row m-0 main-list-panel">
                                                                    <div class="vx-col md:w-1/2 w-full p-0">
                                                                        <div class="main-list">
                                                                            <p>
                                                                                Email
                                                                                <span>{{checkProperty(tenantDetails['petitionerInfo'],'authorizedSignatory'
                                                                                    ,'email')}}</span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="vx-col md:w-1/2 w-full p-0">
                                                                        <div class="main-list">
                                                                            <p>
                                                                                Phone Number

                                                                                <span>
                                                                                    {{checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory
                                                                                    ,"phoneCountryCode"
                                                                                    ,'countryCallingCode')?checkProperty(tenantDetails['petitionerInfo'].authorizedSignatory
                                                                                    ,"phoneCountryCode"
                                                                                    ,'countryCallingCode')+('&nbsp;'):''}}{{tenantDetails['petitionerInfo'].authorizedSignatory.phone}}</span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>

                                                            <!-- </div> -->
                                                            <!-- </div>
                                                </div> -->
                                                            <!-- <div class="tab-inner-content">
                                                                <div class="tabs-content-panel tab-pad-wrap">
                                                                    <div class="main-list-wrap"> -->

                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'],'typeOfBusiness')">
                                                                <div class=" vx-col w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'typeOfBusiness')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Type of Business
                                                                            <span>
                                                                                <pre
                                                                                    style="padding-top:10px;white-space: pre-line;max-width:100%;word-wrap: break-word;    font-family: inherit;"><span>{{checkProperty(tenantDetails,'petitionerInfo','typeOfBusiness')}}</span></pre>
                                                                            </span>


                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'],'natureOfBusiness')">
                                                                <div class=" vx-col w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'natureOfBusiness')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Briefly describe the nature of
                                                                            your
                                                                            business
                                                                            <span>
                                                                                <pre
                                                                                    style="padding-top:10px;white-space: pre-line;max-width:100%;word-wrap: break-word;    font-family: inherit;">{{ checkProperty(tenantDetails,'petitionerInfo' ,'natureOfBusiness')}}</pre>
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'],'businessEstdDate') || checkProperty(tenantDetails['petitionerInfo'],'totalFullTimeEmployees')">
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'businessEstdDate') ">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Date of business was established
                                                                            <span>{{tenantDetails['petitionerInfo'].businessEstdDate
                                                                                | formatDate}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'totalFullTimeEmployees')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Total number of full-time
                                                                            employees
                                                                            <span>{{tenantDetails['petitionerInfo'].totalFullTimeEmployees}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'],'are50orMoreEmployeesInUS') || checkProperty(tenantDetails['petitionerInfo'],'areAbove50PercentH1BL1ALABStatus')">
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'are50orMoreEmployeesInUS')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Are 50 or more individuals
                                                                            employed
                                                                            in
                                                                            United States?
                                                                            <span
                                                                                style="text-transform: capitalize;">{{tenantDetails['petitionerInfo'].are50orMoreEmployeesInUS}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'areAbove50PercentH1BL1ALABStatus')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Are more than 50 percent of
                                                                            those
                                                                            employees
                                                                            in
                                                                            <br />H-1B, L-1A or L-1B
                                                                            nonimmigrant
                                                                            status?
                                                                            <span
                                                                                style="text-transform: capitalize;">{{tenantDetails['petitionerInfo'].areAbove50PercentH1BL1ALABStatus}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'],'estimatedNetAnualIncome') || checkProperty(tenantDetails['petitionerInfo'],'estimatedGrossAnualIncome')">
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'estimatedNetAnualIncome')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Estimated net annual income
                                                                            <span>{{tenantDetails['petitionerInfo'].estimatedNetAnualIncome}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="vx-col md:w-1/2 w-full p-0"
                                                                    v-if="checkProperty(tenantDetails['petitionerInfo'],'estimatedGrossAnualIncome')">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Estimated gross annual income
                                                                            <span>
                                                                                {{tenantDetails['petitionerInfo'].estimatedGrossAnualIncome}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="vx-row m-0 main-list-panel"
                                                                v-if="checkProperty(tenantDetails['petitionerInfo'],'finalDeterminationFromDOL')">
                                                                <div class="vx-col md:w-1/2 w-full p-0">
                                                                    <div class="main-list">
                                                                        <p>
                                                                            Final determination from DOL or
                                                                            Federal
                                                                            Arbitrator of willful
                                                                            violation of any H1B program
                                                                            requirement
                                                                            within 5 years of date.
                                                                            <span
                                                                                style="text-transform: capitalize;">{{tenantDetails['petitionerInfo'].finalDeterminationFromDOL}}</span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- </div>
                                                    </div>
                                                </div> -->
                                            </vs-tab>


                                        </vs-tabs>
                                    </vs-tab>
                                </vs-tabs>

                            </div>

                        </VuePerfectScrollbar>

                    </vs-col>

                </vs-row>
            </div>
        </div>
        <vs-popup class="holamundo main-popup" :title="popupbtnTxt+' Customer'" :active.sync="approveConformpopUp">
            <div class="form-container">

                <div class="vx-row" v-if="[2].indexOf(selectedStatus)>-1">
                    <div class="vx-col w-full">
                        {{actionText}}

                    </div>

                </div>

                <!--------------If reject take comment------->
                <div v-if="[3,4,5].indexOf(selectedStatus)>-1" class="vx-row">

                    <!-- <vs-textarea v-model="actionComent"   label="Write a comment…" class="w-full" /> -->

                    <div class="vx-col w-full">
                        <div class="form_group">
                            <label class="form_label">Comments</label>

                            <!-- <vs-textarea data-vv-as="Comments" v-validate="'required'" v-model="actionComent"
                                name="comments" class="w-full" /> -->
                                <ckeditor  data-vv-as="Comments" v-validate="'required'" v-model="actionComent"
                                name="comments" class="w-full" :editor="editor" :config="editorConfig"></ckeditor>

                        </div>



                    </div>
                    <span class="text-danger text-sm" v-show="errors.has('comments')">{{ errors.first("comments")
                        }}</span>




                </div>

            </div>
            <div class="popup-footer">
                <vs-button color="dark" class="cancel" type="filled" @click="approveConformpopUp=false;">Cancel
                </vs-button>
                <vs-button color="success" class="save"
                    :disabled="[3,4,5].indexOf(selectedStatus)>-1  && actionComent==''" type="filled"
                    @click="changetenantStatus()">{{popupbtnTxt}}</vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import moment from "moment";
import JQuery from "jquery";
import * as _ from "lodash";
import Vue from 'vue';
Vue.use( CKEditor );
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default {
  components: {
  
    VuePerfectScrollbar,
  

  },
  props: {
  },
  computed: {
  },
 
  data: () => ({
    editor: ClassicEditor,
 editorConfig: {
     toolbar: [ 'bold', 'italic', '|', 'undo','redo'  ,'NumberedList', 'BulletedList', ],
 },
    docPrivew: false,
    docValue: "",
    docType: "",
      active_tab:0,
      tenantId:null,
      tenantDetails:null,
      selectedTenant:null,
      selectedStatus:2,
      actionText:"Do you want to approve?",
       approveConformpopUp: false,
       popupbtnTxt:'',
       actionComent:''
    
  }),
  methods: {
    fetchSignedUrl(value) {
        //@download_or_view="download_or_view"
        this.$emit("download_or_view" ,value);
        
      },
      download_or_view(value) {
            if (_.has(value, "path")) {
                value['url'] = value['path'];
                value['document'] = value['path'];
            }

            if (_.has(value, "url")) {
                value['path'] = value['url'];
                value['document'] = value['url'];
            }

            if (_.has(value, "document")) {
                value['path'] = value['document'];
                value['url'] = value['document'];
            }

            this.selectedFile = value;
            this.docValue = '';
            this.docPrivew = false;
            this.docType = false;
            this.docType = this.findmsDoctype(value);

            if (this.docType == "office" || this.docType == "image") {
                
                value.url = value.url.replace(this.$globalgonfig._S3URL, "");
                value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
                let postdata = {
                    keyName: value.url
                };
                this.$store.dispatch("getSignedUrl", postdata).then((response) => {
                    this.docValue = response.data.result.data;

                    if (this.docType == "office") {
                        this.docValue = encodeURIComponent(response.data.result.data);
                    }
                    this.docPrivew = true;
                });

            } else {

                this.downloads3file(value);
            }

        },
        changetenantStatus( ){
        let post_data = {"tenantId":this.selectedTenant['_id'], "statusId":this.selectedStatus }
        //post_data = Object.assign(post_data,{"tenantId":this.selectedTenant['_id'] ,"statusId":this.selectedStatus})
      let action ="changetenantStatus"
       if(this.selectedStatus ==4){
        action = "deleteTenant"
       }
       if( this.actionComent =='' && [3,4,5].indexOf(this.selectedStatus)>-1 ){
         return true;

       }
       if([3,4,5].indexOf(this.selectedStatus)>-1){
        post_data = Object.assign(post_data,{"comment":this.actionComent}) ;
       }
       //alert(action)
       this.$store.dispatch(action, post_data)
          .then(response => {
            this.showToster({message:response.message,isError:false});
            this.approveConformpopUp =false;
            this.getTenantDetails();


          }).catch((er)=>{

            this.showToster({message:er,isError:true});
          
        });
      },
       openApprovepopup(item ,status=2 ,txt=''){
         
        this.actionText = "Do you want to "+txt+"?",
        this.actionComent ='';
        this.popupbtnTxt = txt;
        this.selectedTenant = item;
        this.selectedStatus = status;
        this.approveConformpopUp =true;
         this.$validator.reset();

 
      },
      getTenantDetails() {
        
          let postData = {tenantId:this.tenantId};
           this.$store.dispatch("commonAction", {"data":postData ,"path":"/tenant/details"})
           .then((response) => {
               this.tenantDetails = response;
              

           })
           .catch((err) =>{
                this.tenantDetails =null;
               this.showToster({message:err,isError:true });

           })



      },
    
    getAccountDomain(){
        window.open("https://"+this.checkProperty(this.tenantDetails,'slug')+".immibox.com", '_blank', 'noreferrer');
      // return 
    }
   

   
  },
  mounted() {
      if (this.$route.params && this.$route.params.itemId) {
            this.tenantId = this.$route.params.itemId;
            this.getTenantDetails();
        }
    
     

    
  },
 
};
</script>